<template>
    <div>
        <table class="table table-sm table-hover table-bordered table-striped">
            <thead class="thead-orange">
                <tr>
                    <th>Módulo</th>
                    <th>Descripción</th>
                    <th>Habilitado</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="module in modules" :key="module.id">
                    <td>{{ module.name }}</td>
                    <td>{{ module.description || '—' }}</td>
                    <td>
                        <input
                            type="checkbox"
                            :value="module.id"
                            v-model="selectedModules"
                            @change="onModuleToggle(module)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Configuración por módulo -->
        <div
            v-for="module in modulesWithConfig"
            :key="'config-' + module.id"
            class="module-config-card mt-3 p-3 border rounded bg-light"
        >
            <h6 class="mb-3">
                <i class="fa fa-cog mr-1"></i>
                Configuración: {{ module.name }}
            </h6>
            <div class="row">
                <div
                    v-for="opt in module.config_options"
                    :key="opt.config_key + '-' + (opt.config_type || '')"
                    class="col-12 col-md-4 mb-2"
                >
                    <template v-if="opt.config_type === 'boolean'">
                        <b-form-checkbox
                            :checked="!!getModuleConfigValue(module.id, opt.config_key)"
                            @input="setModuleConfigValue(module.id, opt.config_key, $event)"
                        >
                            {{ formatConfigKey(opt.config_key) }}
                        </b-form-checkbox>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import clientsRepository from '../../../repositories/clients.repository'

export default {
    props: {
        myClient: {
            default: null,
        },
        onAssigning: {
            type: Function,
        },
    },
    data() {
        return {
            modules: [],
            selectedModules: [],
            moduleConfig: {},
        }
    },
    computed: {
        modulesWithConfig() {
            return this.modules.filter(
                m =>
                    this.selectedModules.includes(m.id) &&
                    m.config_options &&
                    m.config_options.length > 0
            )
        },
    },
    watch: {
        myClient(client) {
            if (client && client.id) {
                this.loadModules()
            }
        },
    },
    methods: {
        formatConfigKey(key) {
            const labels = {
                print_name: 'Imprimir nombre',
                print_cc: 'Imprimir cédula',
                print_visitor_type: 'Imprimir tipo de visitante',
            }
            return labels[key] || key.replace(/_/g, ' ')
        },
        getModuleConfigValue(moduleId, key) {
            if (!this.moduleConfig[moduleId]) return null
            return this.moduleConfig[moduleId][key]
        },
        setModuleConfigValue(moduleId, key, value) {
            this.$set(this.moduleConfig, moduleId, this.moduleConfig[moduleId] || {})
            this.$set(this.moduleConfig[moduleId], key, !!value)
        },
        onModuleToggle(module) {
            if (this.selectedModules.includes(module.id) && module.config_options && module.config_options.length) {
                if (!this.moduleConfig[module.id]) {
                    const defaults = {}
                    module.config_options.forEach(opt => {
                        defaults[opt.config_key] = opt.value
                    })
                    this.$set(this.moduleConfig, module.id, defaults)
                }
            } else {
                this.$delete(this.moduleConfig, module.id)
            }
        },
        async loadModules() {
            this.selectedModules = []
            this.modules = []
            this.moduleConfig = {}

            try {
                const cr = { ...clientsRepository }
                const { data } = await cr.loadOptionalModules(this.myClient.id)
                if (data && Array.isArray(data.modules)) {
                    this.modules = data.modules
                    this.selectedModules = data.modules.filter(m => m.enabled).map(m => m.id)
                    data.modules.forEach(m => {
                        if (m.enabled && m.config_options && m.config_options.length) {
                            const cfg = {}
                            m.config_options.forEach(opt => {
                                cfg[opt.config_key] = opt.value
                            })
                            this.$set(this.moduleConfig, m.id, cfg)
                        }
                    })
                }
            } catch (error) {
                toastr.error(
                    'Ocurrió un error al cargar los módulos opcionales del cliente'
                )
            }
        },
        buildModuleConfigsPayload() {
            const out = {}
            this.selectedModules.forEach(moduleId => {
                if (this.moduleConfig[moduleId] && Object.keys(this.moduleConfig[moduleId]).length) {
                    out[moduleId] = { ...this.moduleConfig[moduleId] }
                }
            })
            return out
        },
        async assignOptionalModules() {
            try {
                const payload = {
                    clientId: this.myClient.id,
                    selectedModules: this.selectedModules,
                    moduleConfigs: this.buildModuleConfigsPayload(),
                }
                const cr = { ...clientsRepository }
                const { data } = await cr.assignOptionalModules(payload)
                if (data && data.status) {
                    toastr.success(data.msg)
                    if (Array.isArray(this.modules)) {
                        this.myClient.optional_modules = this.modules.filter(m =>
                            this.selectedModules.includes(m.id)
                        )
                    }
                    typeof this.onAssigning === 'function' &&
                        this.onAssigning()
                } else {
                    toastr.error(
                        (data && data.msg) ||
                            'Ocurrió un error al actualizar los módulos opcionales'
                    )
                }
            } catch (error) {
                toastr.error(
                    'Ocurrió un error al actualizar los módulos opcionales'
                )
            }
        },
    },
    mounted() {
        if (this.myClient && this.myClient.id) {
            this.loadModules()
        }
        this.$bus.$on(
            'assignOptionalModules.save',
            this.assignOptionalModules
        )
    },
    beforeDestroy() {
        this.$bus.$off(
            'assignOptionalModules.save',
            this.assignOptionalModules
        )
    },
}
</script>

<style scoped>
.module-config-card {
    background-color: #f8f9fa;
}
</style>
